var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUploadCloud(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "upload-cloud-01"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M6.66667 27.0704C4.65669 25.7249 3.33333 23.4337 3.33333 20.8333C3.33333 16.9274 6.31918 13.7188 10.1329 13.3656C10.913 8.62022 15.0337 5 20 5C24.9663 5 29.087 8.62022 29.8671 13.3656C33.6808 13.7188 36.6667 16.9274 36.6667 20.8333C36.6667 23.4337 35.3433 25.7249 33.3333 27.0704M26.6667 26.6667L20 20L13.3333 26.6667M20 20V35",
    stroke: "#2565C8",
    strokeWidth: 2.14286,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadCloud);
export default __webpack_public_path__ + "static/media/upload-cloud.29ff16d60f0d6bbd8949909381f87fa2.svg";
export { ForwardRef as ReactComponent };